import React from 'react';
import Header from '../../components/layout/Header.jsx';
import Footer from '../../components/layout/Footer.jsx';
import { Link } from 'react-router-dom';

const TermsAndConditions = () => {
    return (
        <>
            <div className='h-screen flex flex-col relative'>
                <Header title='Terms and conditions' staticHeader={true} sidebar={false} />
                <div className='max-w-3xl w-full mx-auto px-8 py-10 text-theme1-dark'>
                    <div className='mb-4'>
                        <strong>Last Updated:</strong> 31-01-2025
                    </div>
                    <div className='mb-4'>
                        Welcome to{' '}
                        <Link to='/' className='text-theme1-info'>
                            LDR.ai
                        </Link>{' '}
                        (“LDR.ai ,” “we,” “us,” or “our”).{' '}
                        <Link to='/' className='text-theme1-info'>
                            LDR.ai
                        </Link>{' '}
                        is a brand owned and operated by <strong>Kondiment World Wide SRL</strong> (“Kondiment”), a
                        company registered in Romania, with its principal place of business at Romania, Bucharest, Str.
                        General Gheorghe Manu, no. 7, District 1, registered with the Trade Registry (ORC), under no.
                        J40 / 2418 / 27.02.2014, having fiscal code (RO) 32853995.
                    </div>
                    <div className='mb-4'>
                        By accessing or using the{' '}
                        <Link to='/' className='text-theme1-info'>
                            LDR.ai
                        </Link>{' '}
                        website (the “Site”) and/or any related services, you (“you” or the “User”) agree to be bound by
                        the following Terms and Conditions (these “Terms”). These Terms govern your relationship with{' '}
                        <Link to='/' className='text-theme1-info'>
                            LDR.ai
                        </Link>{' '}
                        , a Kondiment brand, and apply to your use of our Site and Services.
                    </div>
                    <div className='mb-8'>
                        If you do not agree with these Terms, you should stop using our Site and Services immediately.
                    </div>

                    <div className='text-lg font-bold mb-2'>1. Acceptance of Terms</div>
                    <div className='mb-4'>
                        <strong>1.1 Binding Agreement</strong>
                        <br />
                        By using the Site or any of our Services, you acknowledge that you have read, understood, and
                        agree to comply with these Terms, as well as any additional policies or guidelines referenced
                        herein.
                    </div>
                    <div className='mb-4'>
                        <strong>1.2 Modifications</strong>
                        <br />
                        We may update or revise these Terms at any time, and such changes will become effective upon
                        posting the updated Terms on the Site. It is your responsibility to review the Terms
                        periodically. Your continued use of the Site or Services following any changes indicates
                        acceptance of those modifications.
                    </div>

                    <div className='text-lg font-bold mb-2'>2. Ownership and Intellectual Property</div>
                    <div className='mb-4'>
                        <strong>2.1 Kondiment and LDR.ai</strong>
                        <br />
                        <Link to='/' className='text-theme1-info'>
                            LDR.ai
                        </Link>{' '}
                        is a brand developed by Kondiment World Wide SRL. Unless otherwise stated, all materials,
                        including text, graphics, logos, icons, images, and software on the Site are the property of
                        Kondiment. They are protected by international copyright, trademark, and other intellectual
                        property laws.
                    </div>
                    <div className='mb-4'>
                        <strong>2.2 License to Use</strong>
                        <br />
                        Subject to these Terms, we grant you a limited, non-exclusive, non-transferable, revocable
                        license to access and use the Site and its Services. You agree not to reproduce, distribute,
                        modify, create derivative works of, publicly display, publicly perform, republish, download,
                        store, or transmit any material from our Site without prior written permission.
                    </div>

                    <div className='text-lg font-bold mb-2'>3. User Responsibilities</div>
                    <div className='mb-4'>
                        <strong>3.1 Account Security</strong>
                        <br />
                        If our Services require you to create an account, you are responsible for maintaining the
                        confidentiality of your login credentials and for any activities that occur under your account.
                        You agree to notify us immediately of any unauthorized access or suspicious activity.
                    </div>
                    <div className='mb-4'>
                        <strong>3.2 Prohibited Conduct</strong>
                        <br />
                        You agree not to use the Site or Services to:
                    </div>
                    <ul className='list-disc list-inside mb-4 ml-6'>
                        <li>Violate any applicable law or regulation.</li>
                        <li>Infringe upon the rights of others, including intellectual property rights.</li>
                        <li>Upload or transmit harmful, defamatory, or offensive content.</li>
                        <li>
                            Interfere with the security or functionality of the Site, including the deployment of
                            viruses, malware, or any other technology that may damage our systems.
                        </li>
                    </ul>
                    <div className='mb-4'>
                        <strong>3.3 Accuracy of Information</strong>
                        <br />
                        You agree to provide accurate, current, and complete information as prompted by our registration
                        or account setup processes. You are solely responsible for the information you provide, and we
                        are not liable for any consequences arising from inaccuracy or incomplete information.
                    </div>

                    <div className='text-lg font-bold mb-2'>4. Third-Party Services</div>
                    <div className='mb-4'>
                        Our Site or Services may include links to third-party websites, applications, or services that
                        are not owned or controlled by{' '}
                        <Link to='/' className='text-theme1-info'>
                            LDR.ai
                        </Link>{' '}
                        or Kondiment. We do not endorse or assume any responsibility for such third-party content. Any
                        interactions with these third parties are solely between you and the third party in question.
                    </div>

                    <div className='text-lg font-bold mb-2'>5. Privacy Policy</div>
                    <div className='mb-4'>
                        We are committed to safeguarding your personal data. Any personal information you provide to{' '}
                        <Link to='/' className='text-theme1-info'>
                            LDR.ai
                        </Link>{' '}
                        is governed by our Privacy Policy, which explains our data collection and processing practices.
                        By using our Site or Services, you consent to the collection and use of your personal
                        information in accordance with our Privacy Policy.
                    </div>

                    <div className='text-lg font-bold mb-2'>6. Limitation of Liability</div>
                    <div className='mb-4'>
                        <strong>6.1 No Warranty</strong>
                        <br />
                        Use of the Site and Services is at your own risk.{' '}
                        <Link to='/' className='text-theme1-info'>
                            LDR.ai
                        </Link>{' '}
                        and Kondiment provide the Site and Services on an “as is” and “as available” basis without any
                        warranties of any kind, either express or implied.
                    </div>
                    <div className='mb-4'>
                        <strong>6.2 Exclusion of Damages</strong>
                        <br />
                        To the fullest extent permitted by law,{' '}
                        <Link to='/' className='text-theme1-info'>
                            LDR.ai
                        </Link>{' '}
                        and Kondiment are not liable for any indirect, incidental, special, punitive, or consequential
                        damages, including but not limited to lost profits or data, arising out of or in connection with
                        your use of the Site or Services.
                    </div>
                    <div className='mb-4'>
                        <strong>6.3 Maximum Liability</strong>
                        <br />
                        In no event shall the collective liability of{' '}
                        <Link to='/' className='text-theme1-info'>
                            LDR.ai
                        </Link>{' '}
                        and Kondiment exceed the amount paid by you for accessing or using the relevant Services during
                        the three (3) months preceding the event giving rise to such liability.
                    </div>

                    <div className='text-lg font-bold mb-2'>7. Indemnification</div>
                    <div className='mb-4'>
                        You agree to indemnify, defend, and hold harmless{' '}
                        <Link to='/' className='text-theme1-info'>
                            LDR.ai
                        </Link>
                        , Kondiment, its affiliates, and their respective officers, directors, employees, contractors,
                        and agents from and against any claims, liabilities, damages, judgments, awards, losses, costs,
                        expenses, or fees (including reasonable attorneys’ fees) arising out of or relating to your
                        violation of these Terms or your use of the Site or Services.
                    </div>

                    <div className='text-lg font-bold mb-2'>8. Termination</div>
                    <div className='mb-4'>
                        We reserve the right to suspend or terminate your access to our Site or Services at any time,
                        with or without notice, for any violation of these Terms or if we determine such action is
                        necessary to protect our interests or those of other users.
                    </div>

                    <div className='text-lg font-bold mb-2'>9. Governing Law and Dispute Resolution</div>
                    <div className='mb-4'>
                        These Terms and any disputes arising under them shall be governed by and construed in accordance
                        with the laws of Romania, without regard to its conflict of laws principles. You agree to submit
                        to the exclusive jurisdiction of the courts located in Romania, Bucharest to resolve any legal
                        matters arising from these Terms.
                    </div>

                    <div className='text-lg font-bold mb-2'>10. Miscellaneous</div>
                    <div className='mb-4'>
                        <strong>10.1 Entire Agreement</strong>
                        <br />
                        These Terms, together with any other policies referenced herein, constitute the entire agreement
                        between you and{' '}
                        <Link to='/' className='text-theme1-info'>
                            LDR.ai
                        </Link>{' '}
                        / Kondiment regarding your use of the Site and Services.
                    </div>
                    <div className='mb-4'>
                        <strong>10.2 Severability</strong>
                        <br />
                        If any provision of these Terms is found to be unlawful, void, or unenforceable, the remaining
                        provisions shall remain in full force and effect.
                    </div>
                    <div className='mb-4'>
                        <strong>10.3 No Waiver</strong>
                        <br />
                        Our failure to enforce any right or provision of these Terms shall not be deemed a waiver of
                        such right or provision.
                    </div>

                    <div className='text-lg font-bold mb-2'>Contact Us</div>
                    <div className='mb-4'>
                        If you have any questions about these Terms, please contact{' '}
                        <Link to='/' className='text-theme1-info'>
                            LDR.ai
                        </Link>{' '}
                        (Kondiment World Wide SRL) at:
                    </div>
                    <ul className='list-disc list-inside mb-4 ml-6'>
                        <li>Email: support@ldr.ai</li>
                        <li>
                            Address: Bucharest, Str. General Gheorghe Manu, no. 7, District 1, registered with the Trade
                            Registry (ORC), under no. J40 / 2418 / 27.02.2014, having fiscal code (RO) 32853995.
                        </li>
                    </ul>

                    <div className='mb-4'>
                        <strong>© 2025 Kondiment World Wide SRL. All rights reserved.</strong>
                        <br />
                        <Link to='/' className='text-theme1-info'>
                            LDR.ai
                        </Link>{' '}
                        is a brand owned and operated by Kondiment World Wide SRL.
                    </div>
                </div>
                <Footer />
            </div>
        </>
    );
};

export default TermsAndConditions;
